<template>
  <Page>
    <BSearch
      :search-list="searchList"
      @on-search="searchHandler"
    >
    </BSearch>
    <BTable
      style="margin-top: 20px;"
      ref="table"
      size="default"
      :rowKey="(text, index) => index"
      :scroll="{ x: true }"
      :columns="columns"
      :data="loadData"
    >
    </BTable>
  </Page>
</template>

<script>
// import moment from 'moment'

export default {
  name: 'Currency',
  data () {
    return {
      queryParam: {},
      loadData: parameter => {
        const request = this.queryParam
        return this.$http.currency.queryCurrencyConfPageList(Object.assign(parameter, { currencyCode: request.currencyCode })).then(response => {
          const { data } = response
          return data
        })
      },
      searchList: [
        {
          label: '币种',
          key: 'currencyCode',
          type: 'select',
          options: [],
          keyValue: true,
          optionKey: 'currencyCode',
          optionValue: 'currencyName'
        }
      ],
      columns: Object.freeze([
        {
          title: '序号',
          fixed: 'left',
          customRender: (text, record, index) => index + 1
        },
        {
          title: '币种名称',
          dataIndex: 'currencyName' // no
        },
        {
          title: '币种简写',
          dataIndex: 'currencyCode'
          // sorter: true,
          // needTotal: true,
          // customRender: (text) => text + ' 次'
        },
        {
          title: '状态',
          dataIndex: 'status',
          customRender: (status, record, index) => {
            // const { currencyStatus } = record // 01 启 02关
            const checked = status === 1
            return (
              <a-switch
                key={record.currencyCode}
                checked-children="启用" un-checked-children="禁用"
                loading={this.changeLoading}
                defaultChecked={checked}
                onChange={value => { this.handleChange(record, value) }}></a-switch>
            )
          }
          // needTotal: true
        },
        {
          title: '创建人', // 请求接口？
          dataIndex: 'creator'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime'
          // customRender: () => '没有'
        },
        {
          title: '更新人',
          dataIndex: 'updater'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime'
        }
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   width: '150px',
        //   scopedSlots: { customRender: 'action' }
        // }
      ]),
      changeLoading: false
    }
  },
  async created () {
    await this.getQueryParams()
  },
  methods: {
    async handleChange (record, value) {
      this.changeLoading = true
      const { succ } = await this.$http.currency.updateCurrencyConf({ currencyCode: record.currencyCode, status: value ? 1 : 0 })
      this.changeLoading = false
      if (succ) {
        this.$message.destroy()
        this.$message.success('状态修改成功!')
        this.$refs.table.refresh()
      }
    },
    async getQueryParams () {
      const { data } = await this.$http.swap.queryAllCurrencyConf({ request: {} })
      const currencyOptions = data.map(it => {
        return {
          ...it,
          key: it.currencyCode,
          value: it.currencyName
        }
      })
      const merchantSelect = this.searchList[0]
      this.$set(this.searchList, 0, Object.assign({}, merchantSelect, { options: currencyOptions }))
    },
    searchHandler (values) {
      this.queryParam = values
      this.$refs.table.refresh(true)
    }
  }
}
</script>

<style scoped lang="less">
</style>
